var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowInCircle = function SvgArrowInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E0F5",
    d: "M17.848 10c0-3.653-2.626-6.912-6.202-7.676a7.9 7.9 0 0 0-5.303.727 7.9 7.9 0 0 0-3.526 3.772 7.9 7.9 0 0 0-.365 5.35 7.9 7.9 0 0 0 2.995 4.224c3.003 2.14 7.222 1.855 9.913-.664A7.9 7.9 0 0 0 17.848 10m-8.27 3.766-2.191-2.14c-.555-.542.285-1.398.838-.858l1.106 1.08V6.73c0-.363.303-.667.666-.667s.667.304.667.667v5.092l1.1-1.101c.548-.548 1.397.3.85.848L10.42 13.76a.6.6 0 0 1-.843.005"
  })));
};
export default SvgArrowInCircle;